<template>
  <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
    <el-date-picker v-model="config[field.key]" type="datetime" placeholder="选择日期时间">
    </el-date-picker>
  </el-form-item>
</template>

<script>
export default {
  name: "tms-type-date-picker-box",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    source: {
      type: String,
    },
  },
  computed: {
    config() {
      if (this.source === "tmsPageConfig") {
        return this.$store.state.tms.pageData;
      }
      if (this.source === "tmsModuleConfig") {
        return this.$store.state.tms.config;
      }
      return this.$store.state.tms.customConfig;
    },
  },
  mounted() {
    if (!this.config[this.field.key]) {
      this.$set(this.config, this.field.key, '');
    }
  },
};
</script>
